import { Component, OnInit } from '@angular/core';
import fileExampleData from './cxone-etl-load-from-file-example.json';

@Component({
    selector: 'cv-load-from-file-tree',
    templateUrl: './load-from-file-tree.component.html',
    styleUrls: ['./load-from-file-tree.component.scss']
})

export class LoadFromFileTreeComponent {
    public fileData = fileExampleData;
    public showPanel = false;

    toggleAccordian(event, panel): void {
        const element = event.target;
        element.classList.toggle("active");
        this.showPanel = !this.showPanel;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    }
}
